<template>
  <div class="main">
    <div class="mainContainer">
      <div class="header">
        <div class="title">
          <div class="placeholder">
            <span></span>
          </div>
          <div class="main_title">
            <span>疯狂卡通</span>
          </div>
          <div class="uploadButton">
            <button @click="uploadPhoto">点击上传</button>
            <input
              type="file"
              ref="uploadPhotoSingle"
              accept="image/*"
              @change="uploadPhoto_change"
              style="display:none;"
            />
          </div>
        </div>
        <!-- <div class="headerImg" :style="`background-image:url(${header_img})`">
        </div> -->
        <div  class="headerImg">
          <img :src="header_img" alt="">
        </div>
        <div class="remindString">
          <span>转换完成后，请在微博分享并@斌叔儿童编程</span>
        </div>
        
      </div>

      <div class="tableContainer">
        <table class="table">
          <tr class="table_tr">
            <!-- <td class="table__url_qrcode">作品二维码</td> -->
            <td class="table__create_time">日期</td>
            <td class="table__status">状态</td>
          </tr>
          <tr
            v-for="(item, index) in my_disney_file_list"
            :key="index"
            class="table_tr"
          >
            <td class="table__create_time tr_border">{{ item.create_time }}</td>
            <td class="table__status tr_border" >
              <button
                @click="copyLink(item.result_pic_name)"
                :style="item.is_transform_finish && item.is_success ? successBtnStyle : null"
              >
                {{!item.is_transform_finish ? "处理中" : item.is_success ? '复制链接' : '处理失败'}}
              </button>
            </td>
          </tr>
        </table>

        <div class="page">
          <el-pagination
            layout="prev, pager, next"
            :total="myDisneyFileListTotal"
            :page-size	="5"
            @current-change="pageChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URLS, Utils } from "../utils";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { types as WorkTypes } from "@/store/modules/work";
import { types as LoginTypes } from "@/store/modules/login";
import QRCode from "qrcodejs2";
import { GET_QINIU_TOKEN } from "@/utils";
import * as qiniu from "qiniu-js";
import {IMG_DISNEY_ACTIVITY} from "@/assets";


export default {
  name: "my_up_load_file",
  data() {
    return {
      fileList: [],

      file_list_data: [],

      forbid_upload: false,

      header_img: IMG_DISNEY_ACTIVITY,

      upload_file_count: 0,
      preview_img_src: "",
      show_preview_img_view: false,

      copyString: "",
      successBtnStyle: {
        backgroundColor: '#add503',
        border: '1px solid #401d1b', 
        borderRadius: '1rem',
        height: '2rem'
      },
      refreshTimer: null,

      uploadFileCountObject: {}
    };
  },
  watch: {
    upload_file_count(val, oldVal){
      if(val > 0 && val <4){
        if(!this.refreshTimer){
          this.refreshTimer = setInterval(()=>{
            this.refresh()
          }, 10000)
        }
      }else {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
      }
    },
  },
  computed: {
    my_disney_file_list() {

      let data = [];
      let process_pic_count = 0
      this.myDisneyFileList.forEach(item => {
        let itemObject = Object.assign({}, item);
        itemObject.create_time = Utils.getTimeString(itemObject.create_time);

        !item.is_transform_finish ? process_pic_count += 1 : null
        data.push(itemObject);
      });
      let preview_img = data.filter(item => item.is_transform_finish && item.is_success)
      this.header_img = preview_img.length > 0 ? preview_img[0].result_pic_name : IMG_DISNEY_ACTIVITY
      if(data.length != 0){
        data[0].is_in_transform_count > 2 ? this.forbid_upload = true : this.forbid_upload = false
      }
      return data;
      
    },
    ...mapState({
    
      userInfo: state => state.login.userInfo,
      myDisneyFileList: state => state.work.my_disney_file_list.data,
      myDisneyFileListTotal: state =>
        state.work.my_disney_file_list.total_count,
      token: state => state.login.token
    })
  },
  created() {
    this.fetchChangeLoginStatus(this.$route.query.token).then(()=>{
      if(!this.token){
        this.$message({
          type: 'error',
          message: '请更新okMath软件至最新版本',
          duration: 5000
        })
        
      }
    })
    //  阻止ios端网页下滑橡皮筋效果
    var startY,endY;
    //记录手指触摸的起点坐标
    document.body.addEventListener('touchstart',function (e) {
        startY = e.touches[0].pageY;
    });
    document.body.addEventListener('touchmove',function (e) {
        endY = e.touches[0].pageY;  //记录手指触摸的移动中的坐标
        //手指下滑，页面到达顶端不能继续下滑
        if(endY>startY&& document.window.scrollTop()<=0){
            e.preventDefault();
        }
      //手指上滑，页面到达底部能继续上滑
        if(endY<startY&& document.window.scrollTop()+ 
            document.window.height()>=document.body[0].scrollHeight){
            e.preventDefault();
        }
    })

  },
  mounted() {
    this.fetchOwnInfo();
    this.fetchMyDisneyFileList({ page: 1 })
  },
  methods: {
    ...mapActions({
      fetchMyDisneyFileList: WorkTypes.FETCH_LIST_MY_DISNEY_FILE,
      fetchCreateDisneyRecord: WorkTypes.FETCH_CREATE_DISNEY_RECORD,
      fetchOwnInfo: LoginTypes.FETCH_USERINFO,
      fetchChangeLoginStatus: LoginTypes.FETCH_CHANGE_LOGIN_STATUS,
    }),
    ...Utils,
    refresh() {
      this.fetchMyDisneyFileList({ page: 1 })
    },
    pageChange(val) {
      this.fetchMyDisneyFileList({ page: val });
    },
    // disney 活动
    uploadPhoto() {
      !this.forbid_upload ? this.$refs.uploadPhotoSingle.click() : this.$message.error('已达到处理上限，请稍后再试！')
    },
    uploadPhoto_change(e) {
      let files = e.target.files;
      if (!files.length) return;
      files = files[0];
      GET_QINIU_TOKEN(
        files.name,
        (key, token) => {
          var observable = qiniu.upload(
            files,
            key,
            token,
            {
              // 文件原文件名
              fname: files.name,

              // 用来放置自定义变量
              params: {},

              // 用来限制上传文件类型，为 null 表示不对类型限制；限制类型放到数组里：["image/png", "image/jpeg", "image/gif"]
              mimeType: null
            },
            {
              // 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false
              // useCdnDomain: true,
              // 根据具体提示修改上传地区，当为 null 或 undefine 时，自动分析上传域名区域
              // region: qiniu.region.z2
            }
          );

          // 上传开始
          var subscription = observable.subscribe({
            next: result => {
              // 主要用来展示进度
              console.log("上传进度(1):", result);
            },
            error: errResult => {
              // 失败报错信息
              console.log("上传失败(2):", errResult);
              let msg = "";
              if (errResult.message.includes("exceed FsizeLimit")) {
                msg = "文件过大";
              }
            },
            complete: result => {
              // 接收成功后返回的信息
              let url = result.url;
              console.log("上传成功(3):", url);
              let file_name = key.split(`${this.userInfo.user_id}/`)[1];
              this.fetchCreateDisneyRecord({ name: file_name }).then(()=>{
                // this.upload_file_count += 1
                // this.upload_file_count >= 3 ? this.forbid_upload = true : this.forbid_upload = false
                setTimeout(()=>{
                  this.fetchMyDisneyFileList({ page: 1 });
                }, 1000)
                
              })
            }
          });
        },
        false
      );
    },
    copyLink(link){
      this.$copyText(link).then( e => {
            this.$message.success('复制成功')
            console.log(e)
      }, function (e) {
            this.$message.error('复制失败,',e)
            console.log(e)
      })
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  .mainContainer {
    margin: 1rem;
    width: 90%;
    height: 100%;
    display: flex;
    flex-direction: column;
    // justify-content: space-evenly;
    .header {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #401d1b;
      // height: 30%;
      .title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .placeholder {
          width: 10%;
        }
        .main_title {
          font-weight: 900;
          width: auto;
        }
        .uploadButton{
          button {
            font-weight: 700;
            width: auto;
            cursor: pointer;
          }
          input {
            position: absolute;
            display: none;
          }
        }
      }
      .headerImg {
        width: 100%;
        background-color: #fdf6df;
        // border: 1px solid #ea5e00;
        border-radius: 0.8rem;
        // height: 50%;
        height:auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 1rem;
        // background-size: 100% 100%;
        // background-repeat: no-repeat;
        img {
          width: 100%;
          border: 1px solid #ea5e00;
          border-radius: 0.8rem;
        }
      }
      .remindString {
        width: 100%;
        margin-top:0.75rem;
        background-color: #fdf6df;
        border: 1px solid #ea5e00;
        border-radius: 0.6rem;
        font-weight: 900;
        height: 3rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 0.9rem;
      }
    }
    .tableContainer {
      margin-top: 0.75rem;
      width: 100%;
      // height: 65%;
      background-color: #fdf6df;
      border: 1px solid #ea5e00;
      border-radius: 0.8rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .table {
        width: 100%;
        .table_tr {
          width: 100%;
          text-align: center;
          .table__create_time {
            width:70%;
          }
          .table__status {
            width: 30%
          }
        }
        tr{
          td {
            height: 3rem;
            font-weight: 500;
            color: #401d1b;
          }
          .table__create_time {
          }
          .table__status{
            button {
              width: 80%;
              font-weight: 500;
            }
          }
          .tr_border {
            border-bottom: 1px solid #d4d4d4;
          }
        }
      }
      .page {
        background-color: #fdf6df;
        .el-pagination {
          background-color: #fdf6df;
        }
        .el-pagination /deep/ button {
          background-color: #fdf6df;
        }
        .el-pagination /deep/ ul {
          li {
            background-color: #fdf6df;
          }
        }

      }
    }
  }
}
</style>
